module.exports = __webpack_public_path__ + "media/images/pepsico-north-america-003f9519d3b1646a606e7988a2002fa4.jpg";